<template>
<zm-dialog :title="form.title" :visible.sync="visible" width="80%" class="short-dialog">
    <zm-form :model="form" label-position="left" style="width: 95%;" label-width="150px" v-show="active === 0">
        <zm-form-item>
            <div slot="label">
                <tip label="Topics" id="request-privilege-topic"></tip>
            </div>
            <zm-select size="small" v-model.trim="form.topicIds" :loading="topicLoading"
                filterable multiple @change="fetchTopicById" style="width: 100%">
                <zm-option v-for="item in topics" :key="item.id" :label="item.name" :value="item.id"></zm-option>
            </zm-select>
        </zm-form-item>
    </zm-form>
    <zm-row v-if="active === 1">
        <zm-col :span="8">
            <b>publishers</b>
            <div class="user-list">
            <zm-checkbox-group vertical v-model="form.publisherUserIds">
                <zm-checkbox v-for="item in publishers" :key="item.id" :label="item.id"
                :class="item.active?'active-user':'inactive-user'">{{ item.name }}</zm-checkbox>
            </zm-checkbox-group>
            </div>
        </zm-col>
        <zm-col :span="8">
            <zm-input size="small" type="text" class="search-app-input" placeholder="search app" v-model.trim="form.search"></zm-input>
            <div class="app-list">
                <div v-for="item in apps" :key="item.id" class="user-privilege" :class="item.active?'active-user':'inactive-user'">
                    <zm-button type="icon" class="zm-icon-left" style="float: left" @click="appendPub(item.id)"
                        :disabled="form.publisherUserIds.indexOf(item.id) !== -1"></zm-button>
                    <span>{{ item.name }}</span>
                    <zm-button type="icon" class="zm-icon-right" style="float: right" @click="appendSub(item.id)"
                        :disabled="form.subscriberUserIds.indexOf(item.id) !== -1"></zm-button>
                </div>
            </div>
        </zm-col>
        <zm-col :span="8">
            <b>subscribers</b>
            <div class="user-list">
            <zm-checkbox-group vertical v-model="form.subscriberUserIds">
                <zm-checkbox v-for="item in subscribers" :key="item.id" :label="item.id"
                :class="item.active?'active-user':'inactive-user'">{{ item.name }}</zm-checkbox>
            </zm-checkbox-group>
            </div>
        </zm-col>
    </zm-row>
    <zm-form v-if="active === 2">
        <div v-for="item in extraInfos" :key="item.key">
            <zm-form-item label-width="100%" required>
                <template slot="label">
                    <tip :label="item.key" :id="'requestTopic-extraInfo-' + item.key"></tip>
                </template>
            </zm-form-item>
            <zm-form-item label-width="0">
                <zm-input type="textarea" size="small" v-model="item.value"></zm-input>
            </zm-form-item>
        </div>
    </zm-form>
    <zm-steps :active="active" finish-status="success" style="margin-top: 10px;">
        <zm-step title="Select Topic"></zm-step>
        <zm-step title="Privileges"></zm-step>
        <zm-step title="Questions"></zm-step>
    </zm-steps>
    <div slot="footer" class="dialog-footer">
        <zm-button size="small" @click="visible = false">Cancel</zm-button>
        <zm-button size="small" type="primary" @click="active--" v-if="active">Previous</zm-button>
        <zm-button size="small" type="primary" @click="active++" v-if="active < 2" :disabled="!form.topicIds.length">Next</zm-button>
        <zm-button size="small" type="primary" @click="save()" :loading="loading" v-if="active === 2">Submit</zm-button>
    </div>
</zm-dialog>
</template>
<script>
import {
getUsers,
getTopics,
getTopicPrivileges
 } from '../../api/index'
import { createRequest, updateRequest,
getRequestExtraInfo,
getRequestById
} from '../../api/request'
import tip from 'components/ToolTip/index'
export default {
    name: 'topicPrivilege',
    components: {
        tip
    },
    props: ['row'],
    data () {
        return {
            topicLoading: false,
            loading: false,
            visible: false,
            active: 0,
            topics: [],
            requestParam: {
                type: 'EDIT_TOPIC_PRIVILEGES'
            },
            extraInfos: [],
            extraLoading: false,
            form: {
                title: '',
                topicIds: [],
                publisherUserIds: [],
                subscriberUserIds: [],
                search: '',
                users: []
            }
        }
    },
    watch: {
        visible () {
            if (this.visible) {
                this.active = 0
                this.init()
            }
        }
    },
    computed: {
        apps () {
            if (this.form.search) {
                return this.form.users.filter(data => {
                    return String(data.name).toLowerCase().indexOf(this.form.search) > -1
                })
            }
            return this.form.users
        },
        publishers () {
            if (this.form.publisherUserIds.length) {
                return this.form.users.filter(data => {
                    return this.form.publisherUserIds.indexOf(data.id) > -1
                })
            }
            return []
        },
        subscribers () {
            if (this.form.subscriberUserIds.length) {
                return this.form.users.filter(data => {
                    return this.form.subscriberUserIds.indexOf(data.id) > -1
                })
            }
            return []
        }
    },
    methods: {
        init () {
            this.getUsers()
            this.fetchTopics()
            if (this.row) {
                this.showEditTopic(this.row)
            } else {
                this.showCreateTopic()
            }
        },
        showCreateTopic () {
            this.form.topicIds = []
            this.form.publisherUserIds = []
            this.form.subscriberUserIds = []
            this.form.search = ''
            this.extraLoading = true
            this.extraInfos = []
            getRequestExtraInfo(this.requestParam.type).then(response => {
                response[this.requestParam.type].map(item => {
                    this.extraInfos.push({
                        key: item,
                        value: ''
                    })
                })
                this.extraLoading = false
            }).catch(() => {
                this.extraLoading = false
            })
        },
        fetchTopicById () {
            this.form.title = 'Edit Privilege'
            this.form.search = ''
            if (this.form.topicIds.length === 1) {
                getTopicPrivileges(this.form.topicIds[0]).then(response => {
                    this.form.publisherUserIds = response.publisherUserIds
                    this.form.subscriberUserIds = response.subscriberUserIds
                })
            } else {
                this.form.publisherUserIds = []
                this.form.subscriberUserIds = []
            }
        },
        showEditTopic (row) {
            getRequestById(row.id).then(response => {
                const data = JSON.parse(response.params)
                this.form.topicIds = data.topicIds
                this.form.publisherUserIds = data.publisherUserIds
                this.form.subscriberUserIds = data.subscriberUserIds
            })
            this.extraLoading = true
            this.extraInfos = []
            getRequestExtraInfo(this.requestParam.type).then(response => {
                response[this.requestParam.type].map(item => {
                    this.extraInfos.push({
                        key: item,
                        value: row.extraInfos[item] ? row.extraInfos[item] : ''
                    })
                })
                this.extraLoading = false
            }).catch(() => {
                this.extraLoading = false
            })
            this.form.title = 'Edit Request'
        },
        save () {
            var extraValid = true
            var extraInfos = {}
            this.extraInfos.map(item => {
                extraInfos[item.key] = item.value
                if (item.value === '') {
                    extraValid = false
                }
            })
            if (extraValid) {
                this.loading = true
                const { topicIds, subscriberUserIds, publisherUserIds } = this.form
                const data = { topicIds,
                    subscriberUserIds,
                    publisherUserIds }
                if (!this.row) {
                    this.requestParam.params = data
                    this.requestParam.extraInfos = extraInfos
                    createRequest(this.requestParam).then(response => {
                        this.$message({
                            message: 'Create request success!',
                            type: 'success'
                        })
                        this.visible = false
                        this.$emit('refreshRequest')
                        this.loading = false
                    }).catch(() => {
                        this.loading = false
                    })
                } else {
                    this.requestParam.params = data
                    this.requestParam.extraInfos = extraInfos
                    updateRequest(this.row.id, this.requestParam).then(response => {
                        this.$message({
                            message: 'Edit request success!',
                            type: 'success'
                        })
                        this.loading = false
                        this.visible = false
                        this.$emit('refreshRequest')
                    }).catch(() => {
                        this.loading = false
                    })
                }
            } else {
                this.$message({
                    message: 'Submit error!',
                    type: 'error'
                })
                return false
            }
        },
        appendPub (id) {
            this.form.publisherUserIds.push(id)
        },
        appendSub (id) {
            this.form.subscriberUserIds.push(id)
        },
        getUsers () {
            getUsers().then(response => {
                this.form.users = response
            })
        },
        fetchTopics () {
            this.topicLoading = true
            getTopics().then(response => {
                this.topics = response
                this.topicLoading = false
            }).catch(() => {
                this.topicLoading = false
            })
        }
    }
}
</script>
<style scoped>
.user-list {
    height: 40vh;
    overflow-y: auto;
    margin: 22px 10px 0 0;
}
.app-list {
    height: 40vh;
    overflow-y: auto;
    margin: 10px 10px 0 10px;
}
.inactive-user {
    background-color: #fce9e9;
}
.active-user {
    background-color: #e0fbd39e;
}
.user-privilege {
    display: inline-block;
    text-align: center;
    width: 100%;
}
.search-app-input {
    width: 80%;
    margin: 0 10px;
}
</style>
